import { render, staticRenderFns } from "./TxPresenterDashboard.vue?vue&type=template&id=113b6e7f&scoped=true"
import script from "./TxPresenterDashboard.vue?vue&type=script&lang=js"
export * from "./TxPresenterDashboard.vue?vue&type=script&lang=js"
import style0 from "./TxPresenterDashboard.vue?vue&type=style&index=0&id=113b6e7f&prod&scoped=true&lang=css"
import style1 from "./TxPresenterDashboard.vue?vue&type=style&index=1&id=113b6e7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b6e7f",
  null
  
)

export default component.exports